import React from 'react';

import { Pagination as MuiPagination, Skeleton } from '@mui/material';

import { LISTING_ROWS_PER_PAGE } from '@kamernet/constants/Listings';
import { AuthContext } from '@kamernet/core/Auth/AuthContext';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { useListingSelectors } from '@kamernet/modules/Listing/context/hooks/useListingSelectors';
import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';
import { useFilterStateDispatcher } from '@kamernet/modules/Listing/hooks/useFilterStateDispatcher';

import styles from './Pagination.module.css';

const PaginationInternal = () => {
  const isMobile = !useMediaIsDesktop();
  const isLoading = useListingSelectors().isLoading();
  const { listingsState } = ListingsContext.useContext();
  const total = useListingSelectors().getNormalListingsCount();
  const { filterStateDispatcher } = useFilterStateDispatcher();
  const { isAuthenticated } = AuthContext.useContext();

  const signupCardSearchPage = !isAuthenticated;
  const totalListingCount = signupCardSearchPage
    ? LISTING_ROWS_PER_PAGE - 1
    : LISTING_ROWS_PER_PAGE;

  const computePageCount = (totalListings: number) => {
    return Math.ceil(totalListings / totalListingCount);
  };

  const totalPageCount = computePageCount(total || 0);

  const handlePaginationChange = React.useCallback(
    (_event: React.ChangeEvent<unknown>, pageNo: number) => {
      window.scrollTo(0, 0);
      filterStateDispatcher({
        ...listingsState.filterResult.filters,
        pageNo,
      });
    },
    [filterStateDispatcher, listingsState.filterResult.filters],
  );

  if (isLoading) {
    return (
      <div className={styles.pagination}>
        <Skeleton variant="rectangular" width={320} height={40} />
      </div>
    );
  }

  if (totalPageCount <= 1) {
    return null;
  }

  return (
    <MuiPagination
      className={styles.pagination}
      size={isMobile ? 'small' : 'medium'}
      count={totalPageCount}
      page={listingsState.filterResult.filters.pageNo || 1}
      shape="rounded"
      onChange={handlePaginationChange}
    />
  );
};

export const Pagination = React.memo(PaginationInternal);
